import initAutosuggest from '../utilities/autosuggest';

export default function initTestSearch() {
  document.querySelectorAll('.tests-search-form').forEach(wrapper => {
    initAutosuggest({
      wrapper,
      inputSelector: '.tests-search',
      listSelector: '.tests-suggestions',
      endpoint: '/actions/lto/search/tests',
      // Optional: if you want extra behaviour on select, add onSelect.
    });
  });
}
